import { extendTheme, theme as baseTheme } from '@chakra-ui/react';
import { theme as proTheme } from '@saas-ui/react';

import { Drawer, Input, Menu, Popover, Select, Table, Textarea } from './components';
import * as foundations from './foundations';

const label = {
  fontSize: 'xs',
  fontWeight: 700,
  lineHeight: '16px',
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
};

export const theme = extendTheme(proTheme, {
  config: {
    initialColorMode: 'system',
    useSystemColorMode: true,
  },
  ...foundations,
  colors: {
    ...proTheme.colors,
    primary: baseTheme.colors.orange,
    secondary: baseTheme.colors.blue,
    brand: baseTheme.colors.orange,
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.8125rem',
    md: '0.875rem',
    lg: '1rem',
    xl: '1.125rem',
    '2xl': '1.25rem',
    '3xl': '1.5rem',
    '4xl': '1.875rem',
    '5xl': '2.25rem',
    '6xl': '3rem',
    '7xl': '3.75rem',
    '8xl': '4.5rem',
    '9xl': '6rem',
  },
  textStyles: {
    // Body
    bodyRegular: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '28px',
      color: 'text.default',
    },
    bodyMedium: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '28px',
      color: 'text.default',
    },
    bodySemibold: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '28px',
      color: 'text.default',
    },
    // Body Small
    bodySmallRegular: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '24px',
      color: 'text.default',
    },
    bodySmallMedium: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '24px',
      color: 'text.default',
    },
    bodySmallSemibold: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '24px',
      color: 'text.default',
    },
    // Caption
    captionRegular: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '20px',
      color: 'text.default',
    },
    captionMedium: {
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '20px',
      color: 'text.default',
    },
    captionSemibold: {
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '20px',
      color: 'text.default',
    },
    // Caption Small
    captionSmallRegular: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      color: 'text.default',
    },
    captionSmallMedium: {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      color: 'text.default',
    },
    captionSmallSemibold: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      color: 'text.default',
    },
    label,
  },
  components: {
    Drawer,
    Table,
    Input,
    Select,
    Textarea,
    Popover,
    Menu,
  },
});
